import styled from 'styled-components';

const css = {};

css.Login = styled.div`
  display: flex;
  align-items: center;
  cursor:pointer;
`;

css.Text = styled.div`
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.44);
`;

css.Label = styled(css.Text)``;

css.Username = styled(css.Text)`
  margin-left: 2px;
`;

export default css;
